import { InterventionTaskResponse } from './intervention.model';

// The parts of the case where its work is done: the steps of the wizard that tasks complete in, and the sections after the wizard.
export type InterventionView =
  | 'tasks'
  | 'sessions'
  | 'reports'
  | 'ConsentAndPreferences'
  | 'ReferralMatching'
  | 'FunctionalImpactAndRisk'
  | 'TreatmentPlanning';

// Where on the intervention page a task is done. Tasks that complete on a system event are done in the step or section that raises that event;
// tasks a person ticks off by hand are done in the Tasks section.
export function viewForTask(task: InterventionTaskResponse): InterventionView {
  switch (task.completesOnEvent) {
    case 'ReferralConsentGranted':
    case 'ServiceConsentGranted':
      return 'ConsentAndPreferences';
    case 'ReferralCreated':
      return 'ReferralMatching';
    case 'AttendanceCaptured':
      return 'sessions';
    case 'CloseOutReportSubmitted':
    case 'OutcomeReportSubmitted':
    case 'ReportApproved':
      return 'reports';
    case 'CiaFinalized':
      return 'TreatmentPlanning';
    case 'RiskScreenerCompleted':
      return 'FunctionalImpactAndRisk';
    default:
      return 'tasks';
  }
}
